import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import GhostButton from '@wix/da-shared-react/pkg/Buttons/GhostButton';
import SolidButton from '@wix/da-shared-react/pkg/Buttons/SolidButton';
import TextButton from '@wix/da-shared-react/pkg/Buttons/TextButton';
import Plus from '@wix/da-shared-react/pkg/Icons/Plus';
import Check from '@wix/da-shared-react/pkg/Icons/Check';
import XTimes from '@wix/da-shared-react/pkg/Icons/XTimes';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface Props {
  group: PapiUser;
  className?: string;
  requestJoin: (group: PapiUser) => void;
  requestLeave: (group: PapiUser) => void;
}

const JoinGroupButton: React.FC<Props> = ({
  group,
  requestJoin,
  requestLeave,
  className,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const [isButtonHovered, setButtonHovered] = useState(false);

  if (group.extendedGroup?.isIngroup) {
    if (isMobile) {
      return (
        <TextButton
          size="small"
          variant="unbranded"
          className={className}
          onClick={() => requestLeave(group)}
        >
          {t('subnavigation.button.memberOfGroup')}
        </TextButton>
      );
    }

    return isButtonHovered ? (
      <SolidButton
        size="small"
        variant="branded-green"
        className={className}
        onClick={() => requestLeave(group)}
        icon={XTimes}
        onMouseLeave={() => setButtonHovered(false)}
      >
        {t('subnavigation.button.memberOfGroup')}
      </SolidButton>
    ) : (
      <GhostButton
        size="small"
        variant="approval-green"
        className={className}
        onClick={() => requestLeave(group)}
        icon={Check}
        onMouseEnter={() => setButtonHovered(true)}
      >
        {t('subnavigation.button.memberOfGroup')}
      </GhostButton>
    );
  }

  if (isMobile) {
    return (
      <TextButton
        size="small"
        variant="approval-green"
        className={className}
        onClick={() => requestJoin(group)}
      >
        {t('subnavigation.button.joinGroup')}
      </TextButton>
    );
  }

  return (
    <SolidButton
      size="small"
      variant="branded-green"
      className={className}
      onClick={() => requestJoin(group)}
      icon={Plus}
    >
      {t('subnavigation.button.joinGroup')}
    </SolidButton>
  );
};
JoinGroupButton.displayName = 'JoinGroupButton';

export default JoinGroupButton;
